import React, { Component } from 'react';
import Formulario from './InformesForm';

class Informes extends Component{
    componentDidMount = () => {
        const { getModulo, listarPaises, listarProductos, listarFamilia,
            listarLinea, listarGrupo, listarForma, listarPrincipioActivo,
            parametrosEmpresa } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        listarProductos();
        listarPaises();
        listarFamilia();
        listarLinea();
        listarGrupo();
        listarForma();
        listarPrincipioActivo();
        parametrosEmpresa();
    }
    render(){
        const { loader, modulo, listaP, listaPro, listaFamilia, reporteRegistrosExcel,
            reporteRegistrosSanitariosVigentes, reporteRegistrosSanitariosPorVencer,
            listaLinea, listaGrupo, listaForma, reporteProductos, listaPrincipio, datos } = this.props;
        return(
            <div>
                <Formulario
                    loader = {loader}
                    modulo = {modulo}
                    obtenerPaises = {listaP}
                    listaPro = {listaPro}
                    reporteRegistrosSanitariosVigentes = {reporteRegistrosSanitariosVigentes}
                    reporteRegistrosSanitariosPorVencer = {reporteRegistrosSanitariosPorVencer}
                    listaFamilia = {listaFamilia}
                    listaLinea = {listaLinea}
                    listaGrupo = {listaGrupo}
                    listaForma = {listaForma}
                    reporteProductos = {reporteProductos}
                    listaPrincipio = {listaPrincipio}
                    reporteRegistrosExcel = {reporteRegistrosExcel}
                    datos = {datos}
                />
            </div>
        );
    }
}

export default Informes;
